const syncSystemThemeLogos = () => {
    const isDark = document.documentElement.getAttribute('data-bs-theme') === 'dark';

    document.querySelectorAll('.branding__logo[data-system-theme-logo="true"]').forEach((logo) => {
        if (!logo.dataset.lightBackgroundImage) {
            logo.dataset.lightBackgroundImage = logo.style.backgroundImage;
        }

        if (isDark) {
            const darkBackgroundImage = getComputedStyle(logo)
                .getPropertyValue('--branding-logo-dark')
                .trim();

            if (darkBackgroundImage) {
                logo.style.setProperty('background-image', darkBackgroundImage, 'important');
            }
        } else {
            logo.style.removeProperty('background-image');
            logo.style.backgroundImage = logo.dataset.lightBackgroundImage;
        }
    });
};

export default () => {
    syncSystemThemeLogos();

    const observer = new MutationObserver(syncSystemThemeLogos);
    observer.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['data-bs-theme'],
    });
};
